module.exports = __webpack_public_path__ + "static/media/glasses.db521e3d.png";